module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fundo fill-height",
    style: (_vm.fundo)
  }, [_c('v-container', {
    attrs: {
      "fixed": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "flex": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "elevation-12",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title primary--text"
  }, [_vm._v("\n          PORTAL DE RESULTADOS\n        ")]), _vm._v(" "), (_vm.logoApp) ? _c('v-card-media', {
    attrs: {
      "src": _vm.logoApp,
      "height": "120px",
      "contain": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "username",
      "label": "Login",
      "id": "username",
      "type": "username",
      "required": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Senha",
      "id": "password",
      "required": "",
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); },
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "primary"
    }
  }, [_vm._v("Entrar")])], 1)], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.textAlerta) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3daf0fc5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 369
// module chunks = 1